var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "image-carousel" },
    [
      _c(
        "swiper",
        { attrs: { options: _vm.swiperOption } },
        [
          _vm._l(_vm.images, function(image) {
            return _c("swiper-slide", { key: image.id }, [
              _c("div", { staticClass: "image-carousel__slide" }, [
                _c("img", {
                  directives: [
                    {
                      name: "lazy",
                      rawName: "v-lazy",
                      value: image.urls.large,
                      expression: "image.urls.large"
                    }
                  ],
                  staticClass: "image-carousel__image",
                  attrs: { srcset: image.srcset, alt: "" }
                }),
                _vm._v(" "),
                image.caption
                  ? _c("p", { staticClass: "image-carousel__caption" }, [
                      _vm._v(
                        "\n          " + _vm._s(image.caption) + "\n        "
                      )
                    ])
                  : _vm._e()
              ])
            ])
          }),
          _vm._v(" "),
          _c("button", {
            staticClass: "swiper-button-prev",
            attrs: { slot: "button-prev" },
            slot: "button-prev"
          }),
          _vm._v(" "),
          _c("button", {
            staticClass: "swiper-button-next",
            attrs: { slot: "button-next" },
            slot: "button-next"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "swiper-pagination",
            attrs: { slot: "pagination" },
            slot: "pagination"
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eaed83ec", { render: render, staticRenderFns: staticRenderFns })
  }
}